<template>
  <a class="participant-swaps-rise-map-item" @click="$emit('to-swap', swap.id)">
    <span
      :class="
        `participant-swaps-rise-map-item__status-bar participant-swaps-rise-map-item__status-bar--${swap.status}`
      "
      >&nbsp;</span
    >
    <div class="participant-swaps-rise-map-item__details">
      <h4 class="participant-swaps-rise-map-item__title">{{ swap.goal }}</h4>
      <p class="participant-swaps-rise-map-item__subtitle">
        <span class="participant-swaps-rise-map-item__description">{{
          swap.description
        }}</span>
        <span class="participant-swaps-rise-map-item__modified-date">{{
          swap.lastModifiedDate | moment('MM/DD')
        }}</span>
      </p>
    </div>
    <v-progress-circular
      class="participant-swaps-rise-map-item__progress"
      :size="40"
      :width="4"
      :color="progressColor"
      :value="swapProgress"
    >
      <v-icon :size="20" :color="progressColor" v-if="swap.status === 'DONE'"
        >bhi-check</v-icon
      >
      <span
        :class="
          `participant-swaps-rise-map-item__progress-label ${progressColor}--text`
        "
        v-else
      >
        {{ swapProgress }}%
      </span>
    </v-progress-circular>
    <v-icon color="accent" class="participant-swaps-rise-map-item__arrow"
      >mdi-arrow-right</v-icon
    >
  </a>
</template>

<script>
export default {
  name: 'ParticipantSwapsRiseMapItem',
  mixins: [],
  components: {},
  props: {
    swap: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {},
  computed: {
    swapProgress() {
      if (this.swap.repeatGoal === 0) return 100
      const percentage = Math.round(
        (this.swap.repeatState / this.swap.repeatGoal) * 100,
      )
      return percentage
    },
    progressColor() {
      if (this.swapProgress <= 0) return 'bhGray2'
      if (this.swapProgress >= 100) return 'bhGreenDark'
      return 'accent'
    },
  },
}
</script>

<style lang="scss">
.participant-swaps-rise-map-item {
  background: #fff;
  border-radius: $border-radius-root / 2;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.04);
  display: flex;
  flex-wrap: nowrap;
  padding: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  width: 100%;

  &__status-bar {
    display: inline-block;
    width: 6px;
    border-radius: 3px;
    margin-right: 8px;

    &--NEW {
      background-color: #704863;
    }

    &--IN_PROGRESS {
      background-color: #19647e;
    }

    &--DONE {
      background-color: #50701f;
    }

    &--REJECTED {
      background-color: var(--bh-red--dark);
    }
  }

  &__details {
    flex: 1;
    max-width: calc(100% - 94px);
    margin-right: 8px;
    align-self: center;
  }

  &__title {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    color: #4e4e4e;
  }

  &__subtitle {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0 !important;
  }

  &__description {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 45px);
    margin-right: 8px;
    color: #4e4e4e;
  }

  &__description,
  &__modified-date {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 0;
  }

  &__modified-date {
    color: #acaeb1;
  }

  &__progress {
    margin: 0 8px;
    align-self: center;

    &-label {
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
    }
  }

  &__arrow {
    align-self: center;
  }
}
</style>
